import { render, staticRenderFns } from "./BarChart2.vue?vue&type=template&id=5209353a&scoped=true"
import script from "./BarChart2.vue?vue&type=script&lang=js"
export * from "./BarChart2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5209353a",
  null
  
)

export default component.exports